import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '@/core/auth/AuthProvider';
import { queryClient } from '@/core/query/queryClient';
import { AdminRouter } from './router';
import '@/styles/admin.css';

const container = document.getElementById('root');
if (!container) throw new Error('Admin application root is missing');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <AdminRouter />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
